// extracted by mini-css-extract-plugin
export var paginationList = "styles-module--paginationList--7l+9e";
export var projectWrapper = "styles-module--projectWrapper--8Ebcc";